import React from 'react';
import BaseComponent from './BaseComponent';
import {auth} from '../firebase';
import Firebase from 'firebase';
import {connect} from 'react-redux';

var facebookProvider = new Firebase.auth.FacebookAuthProvider();

export class PureFacebookLogin extends BaseComponent {
    constructor(props) {
        super(props);
        this.doLogin = this.doLogin.bind(this);
    }

    doLogin() {
        auth
            .signInWithPopup(facebookProvider)
            .catch(error => {
                alert("Login failed: " + error);
                console.error('auth failed:', error);
            })
        ;
    }

    render() {
        const {user} = this.props;

        if (user.uid) {
            return <span className="facebook-login">Logged in as {user.name}</span>;
        }

        return <button onClick={this.doLogin} className="facebook-login btn btn-sm btn-primary">Login with Facebook</button>
    }
}

function mapStateToProps({app}) {
    return {user: app.get('user')};
}

export default connect(mapStateToProps)(PureFacebookLogin);



/** WEBPACK FOOTER **
 ** ./src/components/FacebookLogin.jsx
 **/